import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button/Button';
import PlusIcon from '../../components/Icons/PlusIcon';
import PageTitle from '../../components/Text/PageTitle';
import usePortalConfig from '../../hooks/usePortalConfig/usePortalConfig';
import useRolePermissions from '../../hooks/useRolePermissions/useRolePermissions';
import ESimManagerTable from './components/ESimManagerTable';
import NewConnectionDrawer from './components/NewConnectionDrawer/NewConnectionDrawer';
import NewUserDrawer from './components/NewUserDrawer/NewUserDrawer';

function ESimManager() {
  const [t] = useTranslation();
  const [openUserDrawer, setOpenUserDrawer] = useState(false);
  const [openConnectionDrawer, setOpenConnectionDrawer] = useState(false);
  const { isUserAllowed } = useRolePermissions();
  const [key, setKey] = useState(0);
  const { routePermissions } = usePortalConfig();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PageTitle>{t('pages.eSimManager.title')}</PageTitle>
        <Box sx={{ display: 'flex', marginLeft: 'auto', gap: '1.5rem' }}>
          {isUserAllowed(routePermissions.usersCreate) ? (
            <>
              <Button
                sx={{
                  '& svg path': {
                    fill: '#000 !important',
                    transition: 'fill 0.2s',
                  },
                  '&:hover svg path': {
                    fill: '#fff !important',
                  },
                }}
                onClick={() => {
                  setOpenUserDrawer(true);
                }}
                color="alternative1Button"
                label={
                  <>
                    <Box sx={{ marginRight: '0.5rem' }}>
                      <PlusIcon />
                    </Box>
                    {t('pages.eSimManager.newUserDrawer.button')}
                  </>
                }
              />
              <NewUserDrawer
                onClose={() => {
                  setOpenUserDrawer(false);
                }}
                onNewUserSuccess={() => setKey((prevState) => prevState + 1)}
                open={openUserDrawer}
              />
            </>
          ) : null}
          {isUserAllowed(routePermissions.newConnection) ? (
            <>
              <Button
                onClick={() => {
                  setOpenConnectionDrawer(true);
                }}
                label={
                  <>
                    <Box sx={{ marginRight: '0.5rem' }}>
                      <PlusIcon />
                    </Box>
                    {t('pages.eSimManager.newConnectionDrawer.title')}
                  </>
                }
              />
              <NewConnectionDrawer
                onClose={() => {
                  setOpenConnectionDrawer(false);
                }}
                onNewConnectionSuccess={() => setKey((prevState) => prevState + 1)}
                open={openConnectionDrawer}
              />
            </>
          ) : null}
        </Box>
      </Box>
      <ESimManagerTable key={key} />
    </>
  );
}
export default ESimManager;
